import React, {
  type FunctionComponent,
  type ReactElement,
  useState,
} from 'react';
import { Box, Popover } from '@wix/design-system';
import TopBarButton, {
  type TopBarButtonProps,
} from '../topBarButton/topBarButton';

interface TopBarButtonWithPopoverProps {
  tooltip?: ReactElement | string;
  tooltipContentDataHook?: string;
  interactive?: boolean;
}

const TopBarButtonWithPopover: FunctionComponent<
  TopBarButtonWithPopoverProps & TopBarButtonProps
> = (props) => {
  const [shown, setShown] = useState(false);
  const { tooltip, ...restProps } = props;

  return props.tooltip ? (
    <Box align="center" verticalAlign="middle">
      <Popover
        showArrow
        animate
        placement="bottom"
        shown={shown}
        onMouseEnter={() => setShown(true)}
        onMouseLeave={() => setShown(false)}
        appendTo="window"
        interactive={props.interactive}
        maxWidth={240}
      >
        <Popover.Element>
          <TopBarButton {...restProps} />
        </Popover.Element>
        <Popover.Content>{tooltip}</Popover.Content>
      </Popover>
    </Box>
  ) : (
    <TopBarButton {...restProps} />
  );
};

TopBarButtonWithPopover.displayName = 'TopBarButtonWithPopover';

export default TopBarButtonWithPopover;
